import { render } from 'solid-js/web';
import App from './App.jsx';
import './styles/global.css';

const root = document.getElementById('root');
render(() => <App />, root);

// Ctrl+R / Ctrl+Shift+R (Cmd+R) are the query "Run" / "Run current" shortcuts,
// so in EVERY mode we stop the browser from treating them as (hard-)reload —
// otherwise the run is lost and the workspace + pinned sessions are torn down.
// Crucially we DON'T stopPropagation: the per-tab run handler must still receive
// the event (a previous version swallowed it in PWA mode, so Ctrl+R never ran).
// Hard-reload escape hatches stay available: Ctrl+F5 / Shift+F5. Plain F5 is
// still only swallowed in an installed PWA (it's a legit refresh in a tab). The
// beforeunload prompt remains the catch-all when a query is running / tx is open.
const isStandalone = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

window.addEventListener('keydown', (e) => {
  const ctrl = e.ctrlKey || e.metaKey;
  if (ctrl && (e.key === 'r' || e.key === 'R')) {
    e.preventDefault(); // block reload; let the app's run handler fire (no stopPropagation)
    return;
  }
  if (isStandalone() && e.key === 'F5' && !ctrl && !e.shiftKey) {
    e.preventDefault();
    e.stopPropagation();
  }
}, { capture: true });

// PWA service-worker registration. The SW itself is intentionally minimal
// (pass-through fetch) — it exists so Chrome considers the app installable.
// Served at /sw.js (server-side root passthrough; see internal/server/server.go).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Swallow — first-page-load failures shouldn't disrupt the UI.
    });
  });
}
